<template>
  <MonitorWrapper class-name="fcbr-100-s1-wrap">
    <layout-comp>
      <div slot="left-top" class="part1">
        <div class="column">
          <div class="name">气体浓度</div>
          <div class="value">{{ leftTopData.concentration }} PPM</div>
        </div>
        <div class="center">
          <ModsIcon
            class="state-icon"
            icon="icon-chemical-weapon"
            :wsData="wsData || singleDeviceDetail"
            :mods="mod"
          />
        </div>
        <div class="column">
          <div class="name">当前检测气体</div>
          <div class="value">{{ leftTopData.gasName }}</div>
        </div>
      </div>
      <div slot="left-bottom" class="part2">
        <div class="n-content">
          <div class="detail">
            <n-blocks v-bind="detail" :data="detailData" />
          </div>
          <div class="relative-chart">
            <v-chart :options="relativeValOp" :autoresize="true" />
          </div>
          <div class="ims-chart">
            <!-- <v-chart :options="initImsOp" :autoresize="true" /> -->
            <el-table
              :data="gasData"
              height="100%"
              :row-style="{ height: '31px' }"
              :cell-style="{ padding: '0px' }"
              border
            >
              <el-table-column align="center" label="气体名称" prop="gasRemark"></el-table-column>
              <el-table-column
                width="160px"
                align="center"
                label="检测结果"
                prop="detectionResult"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="right" class="part3">
        <div class="n-content">
          <div class="chart-wrap" v-for="(v, i) in rightEchart" :key="i">
            <v-chart :options="v" :autoresize="true" />
          </div>
        </div>
      </div>
    </layout-comp>
  </MonitorWrapper>
</template>

<script>
import { mapState } from 'vuex';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/echartOption/common';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';

import LayoutComp from '../components/layout-comp.vue';
import NBlocks from './components/blocks.vue';
import ModsIcon from '@/components/mods-icon';

// import { getStateText, getRunstateText } from './utils';
import {
  getStateColor,
  getRunstateColor,
  getStateText,
  getRunstateText
} from '@/utils/deviceUtils/state';

export default {
  name: 'FCBR-100S1',
  mixins: [singleDeviceMixin],
  components: {
    LayoutComp,
    ModsIcon,
    NBlocks
  },
  data() {
    return {
      mod: 'cwaMod',
      count: 0,
      wsData: null,
      gasData: [],
      relativeValOp: lineAreaStyle({
        color: ['#833BBB', '#3368F2'],
        legend: {
          top: 'auto',
          right: '5%',
          icon: 'circle',
          orient: 'vertical',
          textStyle: {
            color: '#fff'
          }
        },
        title: { text: '气体相对浓度', left: 'center' },
        yAxis: { name: 'V' },
        series: [
          {
            name: '正模式浓度',
            type: 'line',
            symbolSize: 10,
            smooth: true,
            data: [],
            areaStyle: { color: graColor('rgba(131, 59, 187, 0.5)', 'rgba(131, 59, 187, 0)') }
          },
          {
            name: '负模式浓度',
            type: 'line',
            symbolSize: 10,
            smooth: true,
            data: [],
            areaStyle: { color: graColor('rgba(51, 104, 242, 0.5)', 'rgba(51, 104, 242, 0)') }
          }
        ]
      }),
      valueOp: ['temp', 'humidity', 'flow'],
      detail: {
        blocks: [
          [
            { label: '设备名称', prop: 'name' },
            { label: '设备编号', prop: 'sn' },
            { label: '设备状态', prop: 'state', formatter: getStateText, decorator: getStateColor },
            {
              label: '运行状态',
              prop: 'runstate',
              formatter: getRunstateText,
              decorator: getRunstateColor
            }
          ],
          [
            { label: '温度', prop: 'temp', formatter: v => `${v} ℃` },
            { label: '湿度', prop: 'humidity', formatter: v => `${v} %RH` },
            { label: '气流', prop: 'flow', formatter: v => `${v} L/min` }
          ]
        ]
      },
      rightEchart: [
        lineAreaStyle({
          color: '#833BBB',
          title: { text: '温度', left: 'center' },
          yAxis: { name: '℃' },
          series: [
            { areaStyle: { color: graColor('rgba(131, 59, 187, 0.5)', 'rgba(131, 59, 187, 0)') } }
          ]
        }),
        lineAreaStyle({
          color: '#3368F2',
          title: { text: '湿度', left: 'center' },
          yAxis: { name: '%RH' },
          series: [
            { areaStyle: { color: graColor('rgba(51, 104, 242, 0.5)', 'rgba(51, 104, 242, 0)') } }
          ]
        }),
        lineAreaStyle({
          color: '#3368F2',
          title: { text: '气流', left: 'center' },
          yAxis: { name: 'L/min' },
          series: [
            { areaStyle: { color: graColor('rgba(51, 104, 242, 0.5)', 'rgba(51, 104, 242, 0)') } }
          ]
        })
      ],
      leftTopData: {
        concentration: '',
        gasName: ''
      }
    };
  },
  computed: {
    ...mapState('history', ['historyDetailData', 'historyDetailDatas']),
    detailData() {
      try {
        const { name, sn, state, runstate, mods } = this.wsData || this.singleDeviceDetail;
        if (!mods) return {};
        const { temp, humidity, flow, concentration, gasName } = mods[this.mod] || {};
        return { name, sn, state, runstate, temp, humidity, flow, concentration, gasName };
      } catch (error) {
        console.error('CWAMod页面设备更新详情数据失败, 数据结构异常: ', error);
      }
      return {};
    }
  },
  methods: {
    upRelativeVal(newVal) {
      const { beginTime } = newVal;
      ['sccell1RData', 'sccell2RData'].forEach((key, index) => {
        const val = newVal.mods[this.mod][key];
        if (!val && val !== 0) return;
        this.relativeValOp.series[index].data.push([beginTime, val]);
      });
      if (this.relativeValOp.series[0].data.length > 20) {
        this.relativeValOp.series[0].data.shift();
        this.relativeValOp.series[1].data.shift();
      }
    },
    upLeftTopData(newVal) {
      if (!newVal.mods) return;
      const { concentration, gasName } = newVal.mods[this.mod] || {};
      this.leftTopData.concentration = concentration;
      this.leftTopData.gasName = gasName;
    },
    upGasData(newVal) {
      this.gasData = newVal.mods[this.mod].detectabilityList;
    },
    upRightChart(newVal) {
      this.rightEchart.forEach((v, i) => {
        v.series[0].data.push([newVal.beginTime, newVal.mods[this.mod][this.valueOp[i]]]);
        if (v.series[0].data.length > 20) {
          v.series[0].data.shift();
        }
      });
    },
    updateData(newVal) {
      if (this.isHisDetail) return;
      // 更新温度湿度气流图
      this.upRightChart(newVal);
      this.upLeftTopData(newVal);
      this.upRelativeVal(newVal);
      this.upGasData(newVal);
    },
    async initPage() {
      // 历史数据进入时
      if (this.isHisDetail) {
        await this.getHistoryDetailData(this.eventId);
        this.wsData = this.historyDetailData;
        this.historyDetailDatas.forEach(newVal => {
          this.upRightChart(newVal);
          this.upRightChart(newVal);
          this.upLeftTopData(newVal);
          this.upGasData(newVal);
          this.upRelativeVal(newVal);
        });
        this.hideLoading();
      }
    }
  },
  created() {
    this.initPage();
  }
};
</script>

<style lang="scss">
.fcbr-100-s1-wrap {
  overflow: hidden;
  height: 100%;
  * {
    box-sizing: border-box;
  }
  .part1 {
    background: rgba(18, 30, 44, 0.6);
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    .line {
      width: 2px;
      height: 100%;
      background: linear-gradient(transparent 0, #00a0e9 50%, transparent 100%);
    }
    .center {
      .state-icon {
        .my-mods-icon {
          width: 110px !important;
          height: 110px !important;
        }
      }
    }
    .column {
      flex: 1;
    }
    .name {
      font-size: 24px;
      color: #00a0e9;
      margin-bottom: 5px;
    }
    .value {
      font-size: 36px;
    }
  }
  .part3,
  .part2 {
    height: 100%;
    padding: 20px;
    .n-content {
      height: 100%;
      padding: 20px;
      background: rgba(18, 30, 44, 0.6);
    }
  }
  .part2 {
    .n-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      .detail {
        padding: 0 2%;
      }
    }
    .relative-chart {
      flex: 1;
    }
    .ims-chart {
      flex: 1;
      .el-table__body {
        height: 100%;
      }
    }
  }
  .part3 {
    .chart-wrap {
      height: 33%;
    }
  }
  .modes-icon {
    justify-content: flex-start !important;
  }
}
</style>
